/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaWaybillVo } from './KoreaWaybillVo';
import {
    KoreaWaybillVoFromJSON,
    KoreaWaybillVoFromJSONTyped,
    KoreaWaybillVoToJSON,
    KoreaWaybillVoToJSONTyped,
} from './KoreaWaybillVo';

/**
 * 
 * @export
 * @interface ResponseKoreaWaybillVo
 */
export interface ResponseKoreaWaybillVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseKoreaWaybillVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseKoreaWaybillVo
     */
    message?: string;
    /**
     * 
     * @type {KoreaWaybillVo}
     * @memberof ResponseKoreaWaybillVo
     */
    data?: KoreaWaybillVo;
}

/**
 * Check if a given object implements the ResponseKoreaWaybillVo interface.
 */
export function instanceOfResponseKoreaWaybillVo(value: object): value is ResponseKoreaWaybillVo {
    return true;
}

export function ResponseKoreaWaybillVoFromJSON(json: any): ResponseKoreaWaybillVo {
    return ResponseKoreaWaybillVoFromJSONTyped(json, false);
}

export function ResponseKoreaWaybillVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseKoreaWaybillVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : KoreaWaybillVoFromJSON(json['data']),
    };
}

export function ResponseKoreaWaybillVoToJSON(json: any): ResponseKoreaWaybillVo {
    return ResponseKoreaWaybillVoToJSONTyped(json, false);
}

export function ResponseKoreaWaybillVoToJSONTyped(value?: ResponseKoreaWaybillVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': KoreaWaybillVoToJSON(value['data']),
    };
}

